export const Primary0 = '#BA9036';
export const Primary1 = '#C39B45';
export const Primary2 = '#F4D89B';
export const Secondary0 = '#353535';
export const Secondary1 = '#707070';
export const Secondary2 = '#000000';
export const Light = '#FFFFFF';
export const Gradient = '180deg, #F4D89B 0%, #C39B45 60.42%, #BA9036 100%';
export const Background1 = '0deg, #000000 0%, #353535 53.13%, #707070 100%';
export const Background2 = '180deg, #000000 0%, #353535 53.13%, #707070 100%';